export default __webpack_public_path__ + "/dist/images/image00022.5a8b4fcdcde321eded2eb5e828ccf1dd.jpg";